<script setup>
import { computed } from 'vue'
import { HModal, HButton } from '@cnd_fe/ui'

const props = defineProps({
  modelValue: Boolean,
  variant: String,
  title: String,
  content: String,
  confirmText: String,
  cancelText: String,
  teleportTo: String
})

const variantClasses = computed(() => {
  switch (props.variant) {
    case 'success':
      return 'alert-success'
    case 'error':
      return 'alert-danger'
    case 'warning':
      return 'alert-warning'
    case 'info':
    default:
      return 'alert-info'
  }
})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

const onConfirm = (callback) => {
  emit('confirm')
  emit('update:modelValue', false)
  callback?.()
}
</script>

<template>
  <Teleport :to="props.teleportTo ? props.teleportTo : 'body'">
    <HModal :model-value="props.modelValue" @update:model-value="(value) => emit('update:modelValue', value)">
      <template #default="{ open, dialogProps, titleProps, descriptionProps, onClose }">
        <div
          id="alertModal"
          :class="['modal fade', open ? 'show d-block' : 'd-none', variantClasses]"
          tabindex="-1"
          aria-labelledBy="alertModalLabel"
          aria-modal="true"
          role="dialog"
        >
          <div class="modal-dialog" v-bind="dialogProps">
            <div class="modal-content">
              <div class="modal-header offset-sm-0 offset-md-0 offset-lg-0">
                <h5 id="alertModalLabel" class="modal-title" v-bind="titleProps">{{ props.title }}</h5>
                <button
                  type="button"
                  class="btn-close"
                  data-coreui-dismiss="modal"
                  aria-label="Close"
                  @click="onClose"
                ></button>
              </div>
              <main class="modal-body">
                <div v-bind="descriptionProps">{{ props.content }}</div>
              </main>
              <footer class="modal-footer">
                <HButton class="btn btn-primary" @click="() => onConfirm(onClose)">{{
                  props.confirmText ?? '확인'
                }}</HButton>
              </footer>
            </div>
          </div>
        </div>
      </template>
    </HModal>
  </Teleport>
</template>

<style scoped>
</style>












